// extracted by mini-css-extract-plugin
export default {"tagline":"Tagline_tagline__jwYF9","dark":"Tagline_dark__01G39"};